let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1qOg7")).then(() => parcelRequire('bFrp8'));